import DashboardIcon from "@mui/icons-material/Dashboard";
import CategoryIcon from "@mui/icons-material/Category";
import GridViewIcon from "@mui/icons-material/GridView";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import WebIcon from "@mui/icons-material/Web";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import SpaIcon from "@mui/icons-material/Spa";
import SettingsIcon from "@mui/icons-material/Settings";

export const drawerSections = [
  {
    title: "Overview",
    items: [
      {
        id: "dashboard",
        icon: <DashboardIcon />,
        label: "Dashboard",
        route: "/admin/dashboard",
      },
    ],
  },
  {
    title: "Catalog",
    items: [
      {
        id: "products",
        icon: <GridViewIcon />,
        label: "Products",
        route: "/admin/products",
      },
      {
        id: "categories",
        icon: <CategoryIcon />,
        label: "Categories",
        route: "/admin/categories",
      },
    ],
  },
  {
    title: "Sales & Customers",
    items: [
      {
        id: "orders",
        icon: <ShoppingCartIcon />,
        label: "Orders",
        route: "/admin/orders",
      },
      {
        id: "users",
        icon: <PeopleIcon />,
        label: "Users",
        route: "/admin/users",
      },
    ],
  },
  {
    title: "Marketing & Content",
    items: [
      {
        id: "coupons",
        icon: <LocalOfferIcon />,
        label: "Coupons",
        route: "/admin/coupons",
      },
    ],
  },
  {
    title: "System & Store",
    items: [
      {
        id: "settings",
        icon: <SettingsIcon />,
        label: "Store Settings",
        route: "/admin/settings",
      },
      {
        id: "sliders",
        icon: <ViewCarouselIcon />,
        label: "Banner Images",
        route: "/admin/sliders",
      },
      {
        id: "properties",
        icon: <SpaIcon />,
        label: "Shop by Properties",
        route: "/admin/properties",
      },
      {
        id: "website",
        icon: <WebIcon />,
        label: "Go to Website",
        route: "/",
      },
    ],
  },
];

export const drawerItems = drawerSections.flatMap((section) => section.items);
